import React from 'react';
import { Button } from '../../ui/button';
import { Code, Copy, Check } from 'lucide-react';

// Code Only Message Component
export const CodeOnlyMessage = ({ message, copiedItems, copyToClipboard }) => {
  const { code, id } = message;

  return (
    <div className="w-full max-w-[95%]" data-testid={`code-only-message-${id}`}>
      <div className="bg-[#302f2c] border border-[#1e3a5f]/50 rounded-2xl overflow-hidden">
        <div className="p-3 border-b border-[#1e3a5f]/30 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Code className="w-4 h-4 text-[#7dd3fc]" />
            <span className="text-[#7dd3fc] font-medium text-sm">{code?.filename}</span>
          </div>
          <Button
            onClick={() => copyToClipboard(code?.code, id)}
            variant="ghost"
            data-testid={`copy-code-only-${id}`}
            className="text-[#888680] hover:text-[#7dd3fc] p-1.5 h-auto"
          >
            {copiedItems[id] ? <Check size={12} /> : <Copy size={12} />}
            <span className="ml-1 text-xs">{copiedItems[id] ? 'Copied' : 'Copy'}</span>
          </Button>
        </div>
        <div className="p-3 bg-[#1a1c1b] overflow-x-auto max-h-48">
          <pre className="text-[#888680] text-xs font-mono whitespace-pre">{code?.code}</pre>
        </div>
      </div>
    </div>
  );
};
